import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "clip-path": "url(#a)"
    }, [
      _createElementVNode("path", { d: "M6.334 8h-.667a.333.333 0 1 1 0-.667h.667a1 1 0 0 0 1-1v-.666a.333.333 0 1 1 .666 0v.666A1.67 1.67 0 0 1 6.334 8M.333 2.667A.333.333 0 0 1 0 2.333v-.666A1.67 1.67 0 0 1 1.667 0h.666a.333.333 0 0 1 0 .667h-.666a1 1 0 0 0-1 1v.666a.333.333 0 0 1-.334.334m2 5.333h-.666A1.67 1.67 0 0 1 0 6.333v-.666a.333.333 0 0 1 .667 0v.666a1 1 0 0 0 1 1h.666a.333.333 0 0 1 0 .667m5.334-5.333a.333.333 0 0 1-.333-.334v-.666a1 1 0 0 0-1-1h-.667a.333.333 0 1 1 0-.667h.667A1.67 1.67 0 0 1 8 1.667v.666a.333.333 0 0 1-.333.334" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h8v8H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }